import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import useEvents from 'lib/hooks/useEvents';
import useGetFilterPills from 'lib/hooks/useGetFilterPills';
import { useSrpFilters, useClearSrpFilters } from 'lib/hooks/useSrpFilters';
import ClearFiltersTapEvent from 'lib/Tracking/Srp/SearchFilters/ClearFiltersTap';
import RemovePillTapEvent from 'lib/Tracking/Srp/SearchFilters/RemovePillTap';

import { FilterPill } from 'types/srpFilters';
import { AdGlobalRefreshContext } from 'contexts/AdGlobalRefreshContext';
import SrpEventContext from 'contexts/SrpEventContext';

import ActiveFilterPill from './FilterPill';
import { styles } from './styles';

export default function FilterPills(): JSX.Element {
  const { refreshGlobalAds } = useContext(AdGlobalRefreshContext);
  const { values: filters, setValues } = useSrpFilters();
  const clearFilters = useClearSrpFilters();
  const filterPills = useGetFilterPills(filters);
  const { t } = useTranslation();
  const logger = useEvents();
  const srpEventContext = useContext(SrpEventContext);

  function removeFilter(removedFilter: FilterPill): void {
    refreshGlobalAds();
    const { resetState } = removedFilter;
    logger.log(RemovePillTapEvent({ sourcePage: srpEventContext.sourcePage }));
    setValues(resetState);
    window.scrollTo(0, 0);
  }

  function onClearFilters(): void {
    refreshGlobalAds();
    logger.log(ClearFiltersTapEvent({ sourcePage: srpEventContext.sourcePage }));
    clearFilters();
  }

  return (
    <>
      {filterPills.length ? (
        <>
          <div className="filter-pills-border" />
          <div className={classNames('filter-pills-list')}>
            {filterPills?.map((filterPill: FilterPill) => (
              <ActiveFilterPill
                pill={filterPill}
                removeFilter={removeFilter}
                key={filterPill.name}
              />
            ))}
            <button className={classNames('clear-filters-button')} onClick={onClearFilters}>
              {t('srp.filters.clearFilters')}
            </button>
          </div>
          <style jsx>{styles}</style>
        </>
      ) : null}
    </>
  );
}
